type ExitFullscreen = typeof document.exitFullscreen;
type RequestFullscreen = typeof document.documentElement.requestFullscreen;

declare global {
  interface Document {
    webkitExitFullscreen: ExitFullscreen;
    mozCancelFullScreen: ExitFullscreen;
    msExitFullscreen: ExitFullscreen;
  }

  interface HTMLElement {
    mozRequestFullScreen: RequestFullscreen;
    webkitRequestFullScreen: RequestFullscreen;
    msRequestFullScreen: RequestFullscreen;
  }
}

/* Code references from https://developers.google.com/maps/documentation/javascript/examples/control-replacement* */
export function requestFullscreen(element: HTMLElement) {
  if (element.requestFullscreen) {
    void element.requestFullscreen();
  } else if (element.webkitRequestFullScreen) {
    void element.webkitRequestFullScreen();
  } else if (element.mozRequestFullScreen) {
    void element.mozRequestFullScreen();
  } else if (element.msRequestFullScreen) {
    void element.msRequestFullScreen();
  }
}
export function exitFullscreen() {
  if (document.exitFullscreen) {
    void document.exitFullscreen();
  } else if (document.webkitExitFullscreen) {
    void document.webkitExitFullscreen();
  } else if (document.mozCancelFullScreen) {
    void document.mozCancelFullScreen();
  } else if (document.msExitFullscreen) {
    void document.msExitFullscreen();
  }
}
